import React from 'react'

export const CanvasTitle = () => {

    return (
      <img
        src="/static/instructor/media/canvas-logo-lms.png"
        className="mr-4"
      />
    )
}
